import { ApiErrorMessage, ApiErrorMessageProps } from 'noddi-ui-web';

import { getErrorCodes } from '../utils/translation';

export const ApiErrorMessageWithTrans = ({ ...rest }: ApiErrorMessageProps) => (
  <ApiErrorMessage {...rest} errorCodes={getErrorCodes()} />
);
